import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-password-guard',
  templateUrl: './password-guard.component.html',
  styleUrls: ['./password-guard.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class PasswordGuardComponent {
  @Output() authenticated = new EventEmitter<void>();

  password: string = '';
  errorMessage: string = '';
  private readonly CORRECT_PASSWORD = 'admin2025';

  checkPassword() {
    if (this.password === this.CORRECT_PASSWORD) {
      this.authenticated.emit();
      this.errorMessage = '';
    } else {
      this.errorMessage = '驗証碼錯誤';
      this.password = '';
    }
  }
}
